import React from 'react';

import Link from './Link';

type MenuItemInfo = {
  target?: string;
  classes: string;
  href: string | undefined;
  title: string;
};

const items: MenuItemInfo[] = [
  {
    classes: 'vggd-menu__item-home',
    href: process.env.REACT_APP_HOME_PAGE_WITH_TRACKING_URL,
    title: 'Trang chủ',
  },
  {
    classes: 'vggd-menu__item-support',
    href: process.env.REACT_APP_SUPPORT_PAGE_URL,
    title: 'Hỗ trợ',
  },
  {
    classes: 'vggd-menu__item-policy',
    href: process.env.REACT_APP_TERMS_URL,
    title: 'Điều khoản',
  },
];

type MenuItemProps = {
  info: MenuItemInfo;
};

const MenuItem = ({ info }: MenuItemProps) => {
  const { classes, href, title } = info;
  return (
    <li>
      <Link
        className={classes}
        href={href || '#'}
        title={title}
        label={title}
      />
    </li>
  );
};

const Menu = () => {
  return (
    <ul className='vggd-menu' style={{marginLeft:0}}>
      {items.map((info, index) => (
        <MenuItem info={info} key={index} />
      ))}
    </ul>
  );
};

export default Menu;
